import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { GetStyledCompImg } from 'common-modules/general/Modules/functions';
import Popup from './FooterPop/Popup';
import PopPage from './FooterPop/FooterPop';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const PopForm = styled.div`
  cursor: pointer;
`;
const PopImg = styled.img``;
const PopSection = styled.span`
  display: flex;
  align-items: flex-start;
  margin-right: 100px;
`;
const TextForm = styled.span`
  color: #666666;
  font-size: 16px;
  line-height: 1.7px;
`;
const PopTitleForm = styled.div``;
const ImgTitle = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-dMd';
  color: #4a5765;
  font-size: 18px;
  font-size: 1.125rem;
`;
const PopArea = () => {
  const [Show, setShow] = useState<boolean>(false);
  const ShowPopActive = () => {
    setShow(true);
  };

  useEffect(() => {
    if (Show) {
      disableBodyScroll(document.body);
    } else {
      enableBodyScroll(document.body);
    }
  }, [Show]);

  return (
    <PopSection>
      <PopForm onClick={ShowPopActive}>
        <PopTitleForm>
          <ImgTitle>Digital Empire</ImgTitle>
          <IoIosArrowRoundForward />
        </PopTitleForm>
        <TextForm>
          지식산업센터 분양 정보를 <br />
          알려드립니다.
        </TextForm>
      </PopForm>
      <PopImg src={GetStyledCompImg('common/footer-digital-empire.png')} />
      <Popup open={Show} popState="footer" setOpen={setShow} dialogSize="large">
        <PopPage setShow={setShow} />
      </Popup>
    </PopSection>
  );
};

export default PopArea;
